import { Modal } from "antd";
import React, { useMemo, useState } from "react";
import BaseInput from "../BaseInput";
import { useMyCohorts } from "../../hooks/useMyCohorts";
import { getInitials } from "../../utils/stringHelpers";
import { Link } from "react-router-dom";
import CohortTimeFilter from "./cohort-time-filter";

function SearchCohortsModal({ open, onClose }) {
  const { data: cohorts = [], isLoading: loading } = useMyCohorts();
  const [searchQuery, setSearchQuery] = useState("");
  const filteredCohorts = useMemo(() => {
    let searchResult = [];

    if (searchQuery) {
      searchResult = cohorts.filter((cohort) =>
        cohort.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return searchResult;
  }, [searchQuery, cohorts?.length]);

  return (
    <div>
      <Modal visible={open} onCancel={onClose} footer={null} closable={false}>
        <div className="flex gap-3">
          <BaseInput
            placeholder="Search cohorts"
            onChange={(e) => setSearchQuery(e.target.value)}
            inputClassName="h-[30px] pl-2 flex-1"
            className="w-full"
          />
          <CohortTimeFilter />
        </div>

        {!!filteredCohorts.length && (
          <div className="border-t pt-[20px] mt-[40px] border-neutral max-h-[400px] overflow-auto">
            {filteredCohorts.map((cohort, index) => (
              <Link to={`/cohort/messages/${cohort?.slug}`} key={index}>
                <button
                  className={
                    "flex items-center p-2 mb-2 w-full border border-transparent hover:bg-[#EFEFFE] rounded-[8px]"
                  }
                  onClick={onClose}
                >
                  <div>
                    <div className="w-[28px] h-[28px] text-[12px] text-[#30307D] font-semibold bg-[#F9F9FF] rounded-[6px] flex items-center justify-center uppercase">
                      {getInitials(cohort?.title)}
                    </div>
                  </div>
                  <p
                    className={
                      "mb-0 pl-2 one-liner font-medium text-[12px] text-[#202053] one-liner"
                    }
                  >
                    {cohort?.title}
                  </p>
                </button>
              </Link>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
}

export default SearchCohortsModal;
